import { render, staticRenderFns } from "./dzjkl.vue?vue&type=template&id=6b32856a&scoped=true&"
import script from "./dzjkl.vue?vue&type=script&lang=js&"
export * from "./dzjkl.vue?vue&type=script&lang=js&"
import style0 from "./dzjkl.vue?vue&type=style&index=0&id=6b32856a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32856a",
  null
  
)

export default component.exports